export const rolesRoutesMap = {
  gestion: {
    path: '/roles/gestion',
    name: 'Gestión de roles',
  },
  nuevo: {
    path: '/roles/nuevo',
    name: 'Nuevo Registro',
  },
  modificar: {
    path: `/roles/modificar`,
    name: 'Actualizar Registro',
  },
}
